import { createReducer, Reducer } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { CookiePolicyActions } from "./actions";
import { CookiePolicy } from "./models";

export const COOKIE_NAME = "cookiePreferences";

const cookie = Cookies.get(COOKIE_NAME);

const initialState: CookiePolicy = {
  showBar: !cookie,
  allowed: !!cookie,
  preferences: cookie ? JSON.parse(cookie) : {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'denied',
  },
};

// Reducer
export const cookiePolicyReducer: Reducer<
  CookiePolicy,
  CookiePolicyActions.Actions
> = createReducer<CookiePolicy>(initialState, (builder) => {
  builder
    .addCase(CookiePolicyActions.setCookiePreferences, (state, action) => {
      state.preferences = { ...state.preferences, ...action.payload };
    })
    .addCase(CookiePolicyActions.acceptCookies, (state) => {
      state.allowed = true;
      state.showBar = false;
    })
    .addCase(CookiePolicyActions.declineCookies, (state) => {
      state.showBar = false;
    });
});
